export default function pluralize(word: string, count = 1, includeCount = true) {
  return `${includeCount ? `${count} ` : ''}${word}${count  !== 1 ? 's' : ''}`
}